import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { piiProps } from 'src/components/DemoBlur';
import { tableCellInnerBoxStyle } from '../../../../styles/NewLeadTableRowStyle';

const CustomLeadNameCell = ({ params }) =>
    <Box sx={{ ...tableCellInnerBoxStyle, justifyContent: 'flex-start' }}>
        <Typography variant="body2" sx={{ fontWeight: 400, fontSize: '0.8125rem' }}>
            <span {...piiProps} style={{ textTransform: 'capitalize' }}>{`${params?.row?.first_name || ''} ${params?.row?.last_name || ''}`.trim()}</span>
        </Typography>
    </Box>;

export default CustomLeadNameCell;

CustomLeadNameCell.propTypes = {
    params: PropTypes.any,
};
